import { type Ref } from 'vue'

import { useReactiveFeatureFlag } from '@/utils/useFeatureFlags'

export const INBOX_ORDER_SUPPORT_RENAME_FLAG = 'inbox_order_support_rename'

/**
 * Reactive Unleash flag for the Feedback → Customer support rename in hermes.
 *
 * When enabled:
 *  - Nav labels and page title read "Customer support" instead of "Feedback".
 *  - The Customer Support reviews table drops the delete column, hides the
 *    location column for single-location brands, and shows an Order Id
 *    column that links to the order detail page with a returnTo back
 *    to brand.feedback.
 *  - The review detail modal title reads "Support Request Details",
 *    drops the delete button, and shows the Order Id link.
 *  - The order Not Found page honors the returnTo query param on close.
 */
export const useInboxOrderSupportRenameFlag = (): Ref<boolean> =>
  useReactiveFeatureFlag(INBOX_ORDER_SUPPORT_RENAME_FLAG).enabled
